import { colors, layers, media, spacing } from '@lamimed/pantheon';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';

import { ContentFadeProps } from '.';

export const ContentFadeWrapper = styled.div<ContentFadeProps>`
  ${({ haveScrollContent, alignment, desktopPosition = 'absolute' }) => css`
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    z-index: ${layers.above};
    pointer-events: none;

    ${media.greaterThan('tablet')`
      position: ${desktopPosition};
      width: ${haveScrollContent ? 'calc(100% - 1rem)' : '100%'};

      ${ContentContainer} {
        justify-content: ${alignment};
      }
    `}
  `};
`;

interface ContentContainerProps
  extends Pick<ContentFadeProps, 'paddingBottom'> {
  hasChildren: boolean;
  fadeColor: ContentFadeProps['color'];
}

export const ContentContainer = styled.div<ContentContainerProps>`
  ${({ hasChildren, paddingBottom = 'medium', fadeColor = 'light' }) => css`
    width: 100%;
    display: flex;
    background-color: ${colors[fadeColor]};
    padding: ${spacing.none} ${spacing.medium} ${spacing[paddingBottom]}
      ${spacing.medium};

    button {
      z-index: ${layers.above};
    }

    ${media.greaterThan('tablet')`
      padding: ${spacing.none} ${spacing.none} ${spacing[paddingBottom]} ${spacing.none};
      width: 100%;
    `};

    ${!hasChildren &&
    css`
      height: 4rem;
    `}
  `}
`;

export const Fade = styled.div<{ fadeColor: ContentFadeProps['color'] }>`
  ${({ fadeColor = 'light' }) => css`
    width: 100%;
    height: 4rem;
    position: relative;
    top: 0.1rem;
    background: linear-gradient(
      180deg,
      ${rgba(colors[fadeColor], 0)},
      ${colors[fadeColor]} 100%
    );
  `};
`;
